import { BackendExceptionResponse } from '../apiTypes';

export const mockBaseMarketplaces: string[] = ['ALLEGRO.PL', 'ALLEGRO.CZ'];

export const mockPricingRuleTemplate = new Blob();

export const mockImportValidationError: BackendExceptionResponse = {
  httpStatus: 400,
  code: 'VALIDATION_ERROR',
  codeDescription: 'Validation of request failed',
  details: [
    'Marketplace (ALLEGRO.SK) is not an allowed Allegro channel for product (01).',
    'Price rule (...) is not allowed for product (01).',
  ].join('\n'),
};
